////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import Button from '@adsk/alloy-react-button';
import styled from 'styled-components';
import {ReactComponent as IconFolderRecursiveSelect} from './assets/Icon_Folder_Recursive.svg';
import {ReactComponent as IconFolderSingleSelect} from './assets/Icon_Folder_Single_Level.svg';
import Theme from "@adsk/alloy-react-theme";

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const FlexColumnCentered = styled(FlexColumn)`
  align-items: center;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 0;
  flex: 1;
`;

const FlexRowCentered = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FlexRowFullCentered = styled(FlexRowCentered)`
  justify-content: center;
`;

const FlexFill = styled.div`
  flex: 1;
  min-height: 0;
`;

const RowSettings = styled(FlexRow)`
  margin-top: 16px;
  padding-bottom: 24px;
`;

const ColumnLabels = styled.div`
  padding-right: 120px;
  width: 22%;
`;

const ColumnValues = styled.div`
  width: 500px;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

const CellDescription = styled.div`
  display: flex;
  flex-flow: column wrap;
  width: 410px;
`;

const CellSelectors = styled.div`
  width: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const RequireToken = styled.span`
  color: red;
  vertical-align: top;
  font-size: small;
  margin: 0 4px;
`;

const ContentWrapper = styled(FlexColumn)`
  padding: 1em;
  min-width: 0;
  overflow: auto;
`;

const ContentScroller = styled.div`
  min-width: 0;
  overflow: auto;
  flex: 1;
  display: flex;
  margin: 0 1px;
`;

const CenteringContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  text-align: center;
`;

const BlueButton = styled(Button)`
  background: ${Theme.colors.adskBlue500};
  color: white;
  align-self: start;
  min-width: 90px;

  &:disabled {
    background: ${Theme.colors._greyAlpha};
  }
`;

const ColumnLeft = styled.div`
  min-width: 10em;
  align-self: center;
  display: flex;
  margin-bottom: 1em;
`;

const ColumnRight = styled.div`
  flex: 1;
  display: flex;
  vertical-align: center;
  margin-bottom: 1em;
`;

const EllipsisCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FolderBlueSingle = styled(IconFolderSingleSelect)`
  color: rgb(6, 150, 215);
  width: 24px;
  height: 24px;
`;

const FolderBlueRecursive = styled(IconFolderRecursiveSelect)`
  color: rgb(6, 150, 215);
  width: 24px;
  height: 24px;
`;

const ValueWrapper = styled.div`
  margin-bottom: 2em;
`;

const LineWrapper = styled.div`
  margin: 0;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
`;

const RadioSpan = styled.span`
  padding-left: 1em;
`;

const RadioOptionWrapper = styled.div`
  margin-top: 0.5em;
  margin-bottom: 0.5em;
`;

export {
  FlexRow,
  FlexRowCentered,
  FlexRowFullCentered,
  FlexColumn,
  FlexColumnCentered,
  FlexFill,
  RowSettings,
  ColumnLabels,
  ColumnValues,
  CellDescription,
  CellSelectors,
  RequireToken,
  ContentWrapper,
  ContentScroller,
  BlueButton,
  CenteringContainer,
  ColumnLeft,
  ColumnRight,
  EllipsisCell,
  FolderBlueSingle,
  FolderBlueRecursive,
  ValueWrapper,
  LineWrapper,
  RadioLabel,
  RadioSpan,
  RadioOptionWrapper,
}